<template>
    <div class="row divCardComponent">
        <div v-if="getOsTicketLogFiltro() !== null" class="cardComponent">
            <img src="./past.png" width="110" alt="">
            <i class="fa fa-sync"></i>
            <h1>{{ getOsTicketLog }}</h1>
            <p>OS TicketLog</p>
        </div>
        <div class="cardComponent">
            <img src="./past.png" width="110" alt="">
            <i class="fa fa-reply-all"></i>
            <h1>{{ getAgAprovacao }}</h1>
            <p>OS Ag. Aprovação</p>
        </div>
        <div class="cardComponent">
            <img src="./past.png" width="110" alt="">
            <i class="fa fa-reply-all"></i>
            <h1>{{ getOsExternas }}</h1>
            <p>OS Externas</p>
        </div>
        <div class="cardComponent">
            <img src="./past.png" width="110" alt="">
            <i class="fa fa-truck"></i>
            <h1>{{ getOsFrota }}</h1>
            <p>OS Interna Veículos</p>
        </div>
        <div class="cardComponent">
            <img src="./past.png" width="110" alt="">
            <i class="fa fa-play"></i>
            <h1>{{ getOsArmazem }}</h1>
            <p>OS Interna Armazém</p>
        </div>
        <div class="cardComponent">
            <img src="./past.png" width="110" alt="">
            <i class="fa fa-retweet"></i>
            <h1>{{ getOsReabertas }}</h1>
            <p>OS Reabertas</p>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },

  computed: {
    getContadores(){
        const contadores =  this.$store.getters['dashboard/getContadores'];
        
        if(!contadores){
            this.$store.dispatch('dashboard/getContadores')

            return []
        }

        return contadores
    },

    getOsTicketLog(){
        const contadores = this.getContadores

        return contadores.os_ticketlog
    },

    getAgAprovacao(){
        const contadores = this.getContadores

        return contadores.os_ag_aprovacao
    },

    getOsExternas(){
        const contadores = this.getContadores

        return contadores.os_externas
    },
    getOsFrota(){
        const contadores = this.getContadores

        return contadores.os_frota
    },
    getOsArmazem(){
        const contadores = this.getContadores

        return contadores.os_armazem
    },
    getOsReabertas(){
        const contadores = this.getContadores

        return contadores.os_reabertas
    },
  },

  mounted() {
    this.$store.dispatch('dashboard/getContadores')
  },

  methods: {
    getOsTicketLogFiltro() {
        if (!this.getContadores || !this.getContadores.os_ticketlog) return null;
        return this.getContadores.os_ticketlog;
    }
  }
}
</script>
<style scoped>
.cardComponent {
    position: relative;
    height: 190px;
    background: linear-gradient(45deg, #62b567, #207972);
    color: #fff;
    border-radius: 25px;
    flex: 1; /* Cada card ocupará a mesma quantidade de espaço */
    margin: 0 5px; /* Adiciona um espaçamento entre os quadrados */
    text-align: center;
    color: white;
    padding: 20px; /* Ajuste conforme necessário */
    
    display: inline-grid;
    justify-content: left;
    align-items: end;
}

.cardComponent i {
    font-size: 34px;
    text-align: left;
}
.cardComponent h1,h2,h3,h4 {
    font-size: 50px;
    margin-bottom: 0px;
    text-align: left;
}
.cardComponent p {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 0px;
    text-align: left;
}

.divCardComponent {
    align-items: center;
}

.divCardComponent img {
    position: absolute;
    right: 0;
    top: 0;
}
</style>
